export const isEmailValid = (email: string): boolean => {
   return (
      email.length > 5 &&
      email.includes('@') &&
      email.includes('.') &&
      email.indexOf('@') === email.lastIndexOf('@') &&
      email.indexOf('@') > 0 &&
      email.indexOf('@') < email.length &&
      email.indexOf('.') > 0 &&
      email.lastIndexOf('.') < email.length &&
      !email.includes(' ')
   )
}
